import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import useRetellWidget from '../hooks/useRetellWidget';

const { FiMenu, FiX, FiPhone, FiMail } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { openWidget } = useRetellWidget();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleEstimateClick = (e) => {
    e.preventDefault();
    console.log("[Header] Get Free Estimate clicked");
    openWidget();
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo - Shrunk to 10 units */}
          <div className="flex items-center">
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752951692574-PAINTTURA%20%283%29.png"
              alt="Painttura Logo"
              className="h-10 mr-3"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Reviews
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Contact
            </button>
          </nav>

          {/* Contact Info & Mobile Menu */}
          <div className="flex items-center space-x-4">
            <div className="hidden lg:flex items-center space-x-4 text-sm">
              <div className="flex items-center text-gray-600">
                <SafeIcon icon={FiPhone} className="w-4 h-4 mr-1" />
                <span>(704) 488-8894</span>
              </div>
              <div className="flex items-center text-gray-600">
                <SafeIcon icon={FiMail} className="w-4 h-4 mr-1" />
                <span>painttura@gmail.com</span>
              </div>
            </div>

            {/* Get Free Estimate Button - Desktop */}
            <button
              onClick={handleEstimateClick}
              className="hidden md:block bg-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors"
              data-open-retell="true"
            >
              Get Free Estimate
            </button>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100"
            >
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden border-t border-gray-200 py-4"
          >
            <nav className="flex flex-col space-y-4">
              {['home', 'about', 'services', 'portfolio', 'reviews', 'contact'].map((section) => (
                <button
                  key={section}
                  onClick={() => scrollToSection(section)}
                  className="text-left text-gray-700 hover:text-blue-600 transition-colors capitalize"
                >
                  {section}
                </button>
              ))}

              {/* Mobile Get Free Estimate Button */}
              <button
                onClick={handleEstimateClick}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors text-center"
                data-open-retell="true"
              >
                Get Free Estimate
              </button>

              <div className="pt-4 border-t border-gray-200">
                <div className="flex flex-col space-y-2 text-sm text-gray-600">
                  <div className="flex items-center">
                    <SafeIcon icon={FiPhone} className="w-4 h-4 mr-2" />
                    <span>(704) 488-8894</span>
                  </div>
                  <div className="flex items-center">
                    <SafeIcon icon={FiMail} className="w-4 h-4 mr-2" />
                    <span>painttura@gmail.com</span>
                  </div>
                </div>
              </div>
            </nav>
          </motion.div>
        )}
      </div>
    </header>
  );
};

export default Header;